const aliases = { taggify: 'tgx', tgx: 'tgx', viooh: 'VIOOH', outcon: 'outcon' };

const normalizeProviders = (values) => [...new Set(values
    .map((value) => String(value ?? '').trim())
    .filter(Boolean)
    .map((value) => aliases[value.toLowerCase()] || value))];

// screen_providers is a string in the v2 API. PHP stores and returns it
// unchanged through serialize/unserialize; JSON also preserves an empty selection.
export const serializeCampaignProviderSource = (providers) =>
    JSON.stringify(normalizeProviders(providers ?? ['tgx']));

export const getCampaignProviderSource = (campaign = {}, screens = []) => {
    const stored = campaign.screen_providers;
    if (Array.isArray(stored)) return normalizeProviders(stored);
    if (typeof stored === 'string' && stored.trim()) {
        try {
            const parsed = JSON.parse(stored);
            if (Array.isArray(parsed)) return normalizeProviders(parsed);
        } catch (_) {
            // Older clients may have saved a provider name or CSV.
        }
        return normalizeProviders(stored.split(','));
    }

    // Older campaigns did not save the filter. Recover it from their inventory
    // instead of hiding their selected screens behind the new-campaign default.
    const inferred = normalizeProviders((screens ?? []).map((screen) => {
        const provider = screen.provider;
        return typeof provider === 'string'
            ? provider
            : provider?.name || provider?.id;
    }));
    return inferred.length ? inferred : ['tgx'];
};
